export enum SettingsSessionEnum {
  MyAccount = 'MyAccount',
  MyMinister = 'MyMinister',
  MyColleagues = 'MyColleagues',
}
